import React from 'react';
import PropTypes from 'prop-types';
import { MediaRichText } from '@nextiva/rich-text-editor';

import propTypeBlockStyling from 'styling/config/editorBlock/PropTypes/blockStyling';
import QuestionNumber from 'components/QuestionNumber';

import RichTextRequiredAsterisk from '../RichTextRequiredAsterisk';
import QuestionLayoutContainer from '../QuestionLayoutContainer/QuestionLayoutContainer';
import { questionLayoutPropType } from '../../../../config/richTextConfig/questionLayout';
import withNewKeyOnLocalFontChange from '../../../styling/hocs/withNewKeyOnLocalFontChange';

import styles from './QuestionRichText.scss';

const QuestionRichText = ({
  renderKey, // TODO #001 Remove renderKey by updating RTE  @sinslav
  content,
  required,
  layout,
  defaultFontSize,
  defaultFont,
  defaultFontColor,
  questionNumber,
  defaultBold,
  defaultItalic,
  defaultUnderline,
  styling,
}) => (
  <QuestionLayoutContainer layout={layout} className={styles.container}>
    {required && <RichTextRequiredAsterisk />}
    {questionNumber && (
      <QuestionNumber number={questionNumber} styling={styling} />
    )}
    <MediaRichText
      key={renderKey} // TODO #001 Remove renderKey by updating RTE  @sinslav
      className={styles.richText}
      value={content}
      defaultFontSize={defaultFontSize}
      defaultFont={defaultFont}
      defaultFontColor={defaultFontColor}
      defaultBold={defaultBold}
      defaultItalic={defaultItalic}
      defaultUnderline={defaultUnderline}
    />
  </QuestionLayoutContainer>
);

QuestionRichText.propTypes = {
  renderKey: PropTypes.string.isRequired,
  defaultBold: PropTypes.bool,
  defaultItalic: PropTypes.bool,
  defaultUnderline: PropTypes.bool,
  content: PropTypes.object,
  required: PropTypes.bool,
  layout: questionLayoutPropType,
  defaultFontSize: PropTypes.number.isRequired,
  defaultFont: PropTypes.string.isRequired,
  defaultFontColor: PropTypes.string.isRequired,
  questionNumber: PropTypes.number,
  styling: propTypeBlockStyling,
};

QuestionRichText.defaultPropTypes = {
  required: false,
};

export default withNewKeyOnLocalFontChange(QuestionRichText);
